export const MobileOTPCodeMask: (string | RegExp)[] = [
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	/\d/
];
